/* AllSet24 theme JS: small, dependency free. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cfg = window.AllSet24 || { routes: { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' }, cartDrawer: true };

  const track = (name, data = {}) => {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: name, ...data }); } catch (e) {}
  };

  /* Reveal on scroll */
  const revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  /* Overlays (mobile menu + cart drawer) */
  let lastFocus = null;
  const openOverlay = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const panel = el.querySelector('[role="dialog"]');
    panel && panel.focus && setTimeout(() => panel.focus(), 50);
  };
  const closeOverlay = (el) => {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  };

  const menu = $('#mobile-nav');
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-open-menu]')) { openOverlay(menu); $('[data-open-menu]')?.setAttribute('aria-expanded', 'true'); }
    if (t.closest('[data-close-menu]')) { closeOverlay(menu); $('[data-open-menu]')?.setAttribute('aria-expanded', 'false'); }
    if (t.closest('[data-close-drawer]')) closeOverlay($('#cart-drawer'));
    const openCart = t.closest('[data-open-cart]');
    if (openCart && cfg.cartDrawer && !document.body.classList.contains('tpl-cart')) {
      e.preventDefault();
      openOverlay($('#cart-drawer'));
    }
    const ext = t.closest('[data-track="ebay_outbound"], a[href*="ebay.com"]');
    if (ext) track('ebay_outbound_click', { url: ext.href });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { $$('.is-open').forEach(closeOverlay); }
  });

  /* Cart */
  const setCount = (n) => {
    $$('[data-cart-count-badge]').forEach((b) => { b.textContent = n; b.hidden = !n; });
  };
  const refreshDrawer = async (sectionsHtml) => {
    let html = sectionsHtml;
    if (!html) {
      const r = await fetch(`${cfg.routes.root || '/'}?sections=cart-drawer`);
      html = (await r.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#cart-drawer');
    const cur = $('#cart-drawer');
    if (fresh && cur) {
      const wasOpen = cur.classList.contains('is-open');
      cur.innerHTML = fresh.innerHTML;
      setCount(parseInt(fresh.dataset.cartCount || '0', 10));
      if (wasOpen) cur.classList.add('is-open');
    }
  };

  const form = $('[data-product-form]');
  if (form) {
    const btn = $('[data-add-btn]', form);
    const err = $('[data-form-error]', form);
    form.addEventListener('submit', async (e) => {
      if (!btn) return;
      e.preventDefault();
      btn.classList.add('is-loading');
      btn.disabled = true;
      err.hidden = true;
      try {
        const fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', window.location.pathname);
        const r = await fetch(`${cfg.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        const data = await r.json();
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add this box.');
        await refreshDrawer(data.sections && data.sections['cart-drawer']);
        btn.outerHTML = `<a class="btn btn--block" href="${cfg.routes.cart}" data-open-cart>In your cart · View cart</a>`;
        const sticky = $('[data-sticky-add]');
        if (sticky) sticky.outerHTML = `<a class="btn" href="${cfg.routes.cart}" data-open-cart>View cart</a>`;
        track('box_added_to_cart', { product_id: form.closest('[data-product-id]')?.dataset.productId });
        if (cfg.cartDrawer) openOverlay($('#cart-drawer'));
        else window.location.href = cfg.routes.cart;
      } catch (ex) {
        const msg = String(ex.message || '');
        err.textContent = /quantity|stock|available/i.test(msg) ? 'Sorry, this box was just claimed by someone else.' : msg;
        err.hidden = false;
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    });
  }

  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-remove]');
    if (!rm) return;
    e.preventDefault();
    rm.textContent = 'Removing…';
    const r = await fetch(`${cfg.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: rm.dataset.remove, quantity: 0, sections: ['cart-drawer'] })
    });
    if (document.body.classList.contains('tpl-cart') || document.body.classList.contains('tpl-product')) { window.location.reload(); return; }
    const data = await r.json();
    await refreshDrawer(data.sections && data.sections['cart-drawer']);
  });

  /* Lightweight video embeds: load the player only when tapped */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-yt], [data-vimeo]');
    if (!b) return;
    const wrap = b.closest('[data-video]') || b.parentElement;
    const iframe = document.createElement('iframe');
    if (b.dataset.yt) {
      iframe.src = `https://www.youtube-nocookie.com/embed/${b.dataset.yt}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
    } else {
      iframe.src = `https://player.vimeo.com/video/${b.dataset.vimeo}?autoplay=1`;
    }
    iframe.title = b.getAttribute('aria-label') || 'Video';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    wrap.innerHTML = '';
    wrap.appendChild(iframe);
    track('box_video_play', { video: b.dataset.yt || b.dataset.vimeo, path: location.pathname });
  });
  $$('video').forEach((v) => v.addEventListener('play', () => track('box_video_play', { path: location.pathname }), { once: true }));

  /* Product media thumbnails */
  $$('[data-media-thumb]').forEach((t) => {
    t.addEventListener('click', () => {
      const id = t.dataset.mediaThumb;
      $$('[data-media-panel]').forEach((p) => { p.hidden = p.dataset.mediaPanel !== id; });
      $$('[data-media-thumb]').forEach((x) => x.setAttribute('aria-current', x === t ? 'true' : 'false'));
    });
  });

  /* Mobile sticky buy bar */
  const sticky = $('[data-sticky-buy]');
  const buybox = $('#buybox .buybox__actions');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      sticky.classList.toggle('is-visible', !e.isIntersecting);
    }).observe(buybox);
    sticky.addEventListener('click', (e) => {
      if (e.target.closest('[data-sticky-add]')) {
        const f = $('[data-product-form]');
        f && (f.requestSubmit ? f.requestSubmit() : f.submit());
      }
    });
  }

  /* Collection sort */
  const sort = $('[data-sort]');
  sort && sort.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });
})();
